module.exports = __webpack_public_path__ + "img/20191105164024339.2650f0e9.jpg";